export const availableLanguages = [
    {
        code: 'en',
        name: 'English',
        language: 'en-US',
        files: [ 'en.json', 'auth-en.json', 'homePage-en.json', 'shopPage-en.json', 'cart-en.json', 'checkoutPage-en.json', 'thanksPage-en.json', 'error-en.json' ]
    },
    {
        code: 'fr',
        language: 'fr-FR',
        name: 'French',
        files: [ 'fr.json', 'auth-fr.json', 'homePage-fr.json', 'shopPage-fr.json', 'cart-fr.json', 'checkoutPage-fr.json', 'thanksPage-fr.json', 'error-fr.json' ]
    },
    {
        code: 'nl',
        name: 'Dutch',
        language: 'nl-NL',
        files: [ 'nl.json', 'auth-nl.json', 'homePage-nl.json', 'shopPage-nl.json', 'cart-nl.json', 'checkoutPage-nl.json', 'thanksPage-nl.json', 'error-nl.json' ]
    },
    {
        code: 'de',
        name: 'German',
        language: 'de-DE',
        files: [ 'de.json', 'auth-de.json', 'homePage-de.json', 'shopPage-de.json', 'cart-de.json', 'checkoutPage-de.json', 'thanksPage-de.json', 'error-de.json' ]
    },
    {
        code: 'it',
        name: 'Italian',
        language: 'it-IT',
        files: [ 'it.json', 'auth-it.json', 'homePage-it.json', 'shopPage-it.json', 'cart-it.json', 'checkoutPage-it.json', 'thanksPage-it.json', 'error-it.json' ]
    }
]
